import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, Typography } from '@mui/material';

import * as Styled from './styled';

interface PropsType {
	onClose: () => void;
	onAgree: () => void;
	isOpen: boolean;
}

function HomeWorkModal({ onClose, onAgree, isOpen }: PropsType) {
	const { t } = useTranslation();

	return (
		<Styled.Animation isOpen={isOpen}>
			<Styled.Modal>
				<Typography variant="h4" color="#5C5C5C">
					{t('lesson.testRules.test')}
				</Typography>
				<Styled.Wrapper>
					<Styled.InnerWrap>
						<Box display="flex" gap="4px">
							<Typography variant="h3" color="#D81313">
								{t('lesson.testRules.attention')}
							</Typography>
							<Typography variant="h3" color="#333333">
								{t('lesson.testRules.videoSurveillance')}
							</Typography>
						</Box>
						<Typography variant="body1">
							{t('lesson.testRules.description')}
						</Typography>
					</Styled.InnerWrap>
					<Styled.InnerWrap>
						<Typography variant="h4" color="#333333">
							{t('lesson.testRules.title')}
						</Typography>
						<Typography variant="body1" color="#333333">
							📹 <b>{t('lesson.testRules.monitoring')}</b>{' '}
							{t('lesson.testRules.monitoringDescription')}
						</Typography>
						<Typography variant="body1" color="#333333">
							🚫 <b>{t('lesson.testRules.prohibited')}</b>{' '}
							{t('lesson.testRules.prohibitedDescription')}
						</Typography>
						<Typography variant="body1" color="#333333">
							⏳ <b>{t('lesson.testRules.timeLimited')}</b>{' '}
							{t('lesson.testRules.timeLimitedDescription')}
						</Typography>
					</Styled.InnerWrap>
					<Styled.InnerWrap>
						<Typography variant="body1" color="#474747">
							✅ <b>{t('lesson.testRules.mustAgree')}</b>
						</Typography>
						<Typography variant="body1" color="#474747">
							❌ {t('lesson.testRules.disagreeDescription')}
						</Typography>
					</Styled.InnerWrap>
				</Styled.Wrapper>
				<Styled.FooterWrapper>
					<Button
						variant="text"
						sx={{ flex: 1, fontSize: '13px', padding: '10px 16px', height: 'auto' }}
						onClick={onClose}
					>
						❌ {t('lesson.testRules.doNotAgree')}
					</Button>
					<Button
						variant="contained"
						sx={{ flex: 1, fontSize: '13px', padding: '10px 16px', height: 'auto' }}
						onClick={onAgree}
					>
						✔️ {t('lesson.testRules.agree')}
					</Button>
				</Styled.FooterWrapper>
			</Styled.Modal>
			<Styled.Backdrop onClick={onClose} role="button" tabIndex={0} />
		</Styled.Animation>
	);
}

export default observer(HomeWorkModal);
